import HTTP from './axios';

const PatientDependentService = {
  all: (patientId, calendarId) => {
    const p = (calendarId) ? `?calendarId=${calendarId}` : '';
    return HTTP.get(`/patients/${patientId}/covenants${p}`).then(response => response.data.data);
  },
  allPatients: patientId => HTTP.get(`/patients/${patientId}/covenants/all`).then(response => response.data.data),
  one: id => HTTP.get(`/patients/covenants/${id}`).then(response => response.data.data),
  create: covenant => HTTP.post('/patients/covenants', covenant).then(response => response.data.data),
  update: covenant => HTTP.put('/patients/covenants', covenant).then(response => response.data.data),
  remove: id => HTTP.put(`/patients/covenants/${id}`).then(response => response.data.data),
};

export default PatientDependentService;
